export default __webpack_public_path__ + "static/media/success.285f4a06.png";